import React, { useCallback } from "react";
import styled from "styled-components";
import { ResultHeader } from "@witbooking/react-components";
import { default as constants } from "../../utils/constants";
import media from "../../utils/media";
import ResultBlock from "../ResultBlock/ResultBlock";
const StyledResultHeader = styled(ResultHeader) `
  border-bottom: none;
  margin-bottom: 0;

  ${media.up.md `
    padding: 0;
    margin-bottom: 20px;
  `};
`;
function Room({ entity, nature, onImageClick, onBack, onHeaderClick, children, filters, buttonBar, propertyName, propertyCity, propertyTicker, }) {
    const propertyPicture = entity.media && entity.media[0] && entity.media[0].url;
    const handleImageClick = useCallback((event) => onImageClick(entity.media, entity.name, entity.description, null, null, null, event), [entity]);
    const handleBack = useCallback(event => onBack({ event, propertyTicker }), [propertyTicker]);
    const header = nature !== constants.RESULT_HEADER_NATURE.LARGE && (<StyledResultHeader hasBackButton nature={nature} title={entity.name} subtitle={`${propertyName}, ${propertyCity}`} image={propertyPicture} onClick={onHeaderClick} onImageClick={handleImageClick} onBack={handleBack}/>);
    return (<ResultBlock header={header} content={children} nature={nature} filters={filters} buttonBar={buttonBar}/>);
}
export default React.memo(Room);
